import React, { PureComponent } from 'react';
import RichTextEditor from 'react-rte';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import msgs from '../../config/messages';
import BannerHOC from './BannerHOC';

import './Banner.scss';

class Banner extends PureComponent {
  static propTypes = {
    bannerText: PropTypes.string.isRequired,
    uploadBanner: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    // why give auth here you ask? see line 37 in HOC for reason
    // eslint-disable-next-line
    auth: PropTypes.shape({
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
  };

  render() {
    const { bannerText, uploadBanner, handleChange } = this.props;
    return (
      <div className="admin-banner-page">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Banner Page</title>
        </Helmet>
        <div className="admin-banner-header-container">
          <div className="admin-banner-gradient-header">
            <div className="admin-banner-gradient-title">Edit Homepage Banner</div>
            <div className="admin-banner-subheader">Manage the homepage banner to highlight news, alerts, or special announcements.</div>
          </div>
        </div>
        <section className="nf-home__section--landing">
          {/* Semi-transparent overlay for contrast */}
          <div className="admin-banner-overlay" />
          {/* Centered Card */}
          <div className="banner-edit-card">
            <h1 className="banner-edit-main-header">{msgs.HomePage.mainHeader}</h1>
            <div className="banner-edit-divider" />

            <label htmlFor="banner-editor" className="banner-edit-label">Type your message here:</label>
            <div style={{ width: '100%' }}>
              <RichTextEditor
                id="banner-editor"
                value={bannerText}
                className="ghost-input"
                onChange={handleChange}
                onBlur={uploadBanner}
              />
            </div>
            <button className="banner-edit-save-btn" onClick={uploadBanner} type="button">Save</button>
          </div>
        </section>
      </div>
    );
  }
}

export default BannerHOC(Banner);



// WEBPACK FOOTER //
// ./src/pages/Banner/Banner.jsx